import React, { ReactElement } from "react";
import styled from "styled-components";
import ConfirmBtn from "../Button/ConfirmBtn";
import Flex from "../DefaultStyles/Flex";
import { Overlay } from "./DefaultModalLayout";

interface SDesc {
  isSmallDesc?: number;
}

interface AlertModalProps extends SDesc {
  title?: ReactElement<any, any> | string; // element or string
  desc?: string;
  pointDesc?: ReactElement<any, any> | string;
  confirmText?: string;
  cancelEvent?: () => void;
  confirmEvent?: () => void;
  btnColor?: string;
  customConfirmBtn?: JSX.Element;
  customCancelBtn?: JSX.Element;
  customBtns?: JSX.Element;
}

export default function AlertModal({
  title,
  desc,
  pointDesc,
  confirmText,
  cancelEvent,
  confirmEvent,
  btnColor,
  customConfirmBtn,
  customCancelBtn,
  isSmallDesc,
  customBtns,
}: AlertModalProps) {
  return (
    <Overlay id="parent" style={{ zIndex: 30 }}>
      <ModalContainer>
        <div>
          <Title>{title}</Title>

          {desc && <Desc isSmallDesc={isSmallDesc}>{desc}</Desc>}

          {pointDesc && <PointDesc>{pointDesc}</PointDesc>}
        </div>

        <BtnContainer customBtns={Boolean(customBtns)}>
          {customBtns ?? (
            <Flex gapSize={8}>
              <>
                {customCancelBtn ?? (
                  <ConfirmBtn
                    btnText="취소"
                    btnColor="white"
                    btnClickEvent={() => {
                      if (cancelEvent) {
                        cancelEvent();
                      }
                    }}
                  />
                )}

                {customConfirmBtn ?? (
                  <ConfirmBtn
                    btnText={confirmText ?? "확인"}
                    btnColor={btnColor ?? "red"}
                    btnClickEvent={() => {
                      if (confirmEvent) {
                        confirmEvent();
                      }
                    }}
                  />
                )}
              </>
            </Flex>
          )}
        </BtnContainer>
      </ModalContainer>
    </Overlay>
  );
}

const ModalContainer = styled.div`
  max-width: 315px;
  width: 100%;
  min-height: 181px;
  height: auto;
  border-radius: 14px;
  padding: 28px 28px 20px 28px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 30;
  background-color: ${({ theme }) => theme.color.white};

  @media screen and (max-width: 320px) {
    max-width: calc(100vw - 40px);
  }
`;

const Title = styled.h1`
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  text-align: left;
  color: ${({ theme }) => theme.color.textColor};
  word-break: keep-all;
  white-space: pre-line;

  strong {
    color: ${({ theme }) => theme.buttonColor.redNormal};
    font-weight: bold;
  }
`;

const Desc = styled.p<SDesc>`
  margin: 8px 0;
  font-size: ${({ isSmallDesc }) => isSmallDesc ?? 14}px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: ${({ theme }) => theme.color.gray600};
  word-break: keep-all;
  white-space: pre-line;
`;

const PointDesc = styled.div`
  margin: 10px 0;
  background-color: ${({ theme }) => theme.color.bgColor};
  border-radius: 10px;
  padding: 10px;
  word-break: keep-all;
  white-space: pre-line;

  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: #1e1e1e;

  strong {
    font-weight: bold;
  }
`;

const BtnContainer = styled.div<{ customBtns?: boolean }>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: ${({ customBtns }) => (customBtns ? "absolute" : "static")};
`;
